<div class="col-xl">
  <div class="card-wrapper card-space">
    <div class="card card-bg">
      <div class="container mt-4 mb-2" *ngIf="configurazioneGeneraleService.configurazione && configurazioneGeneraleService.configurazione.backButtonIsPresent">
        <nav class="breadcrumb-container" aria-label="Percorso di navigazione" *ngIf="isLoggedIn">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToHome()">Home</a><span class="separator">/</span></li>
            <li class="breadcrumb-item" *ngIf="checkPreviousListaPrenotazioni()"><a href="javascript:void(0)" (click)="goToListaPrenotazioni()">Lista prenotazioni</a><span class="separator">/</span></li>
            <li class="breadcrumb-item active"><a href="javascript:void(0)">Nuovo appuntamento</a></li>
          </ol>
        </nav>
      </div>
      <div class="card-body">
        <div style="justify-content: center;" *ngIf="isLoggedIn">
          <div class="container">
            <div class="row" style="justify-content: center; text-align: center; margin-top: 10%;">
              <div class="col-xl-8 col-lg-12">
                <h3><b jhiTranslate="form.prenota.prenotaUnAppuntamento">Prenota un Appuntamento</b></h3>
                <hr style="opacity:1; color: black;">
              </div>
            </div>
            <div class="row" style="justify-content: center;">
              <div class="col-xl-8 col-lg-12">
                <div class="card mb-0 pb-0">
                  <div class="card-body mt-2 mb-0 p-0">
                    <div class="d-flex justify-content-between" *ngIf="isLoggedIn">
                      <button (click)="goToInserimentoDatiPrenotazione()"
                              class="btn btn-primary primary-button"
                              jhiTranslate="form.prenota.perMe" joyrideStep="primoStep"
                              [stepContent]="primoStep" [nextTemplate]="nextButton" [prevTemplate]="prevButton">Per Me
                        <svg class="icon icon-white">
                          <use href="./content/svg/sprites.svg#it-chevron-right">
                          </use>
                        </svg>
                      </button>
                      <button (click)="goToInserimentoDatiPrenotazioneperUnaltro()"
                              class="btn btn-primary primary-button"
                              jhiTranslate="form.prenota.perUnAltro" joyrideStep="secondoStep"
                              [stepContent]="secondoStep" [nextTemplate]="nextButton" [prevTemplate]="prevButton">Per un Altro
                        <svg class="icon icon-white">
                          <use href="./content/svg/sprites.svg#it-chevron-right">
                          </use>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!isLoggedIn">
          <jhi-landing></jhi-landing>
        </div>
      </div>
    </div>
  </div>
</div>
<div><button class="btn btn-secondary btn-xs btn-tour" (click)="onTour();">Tour</button></div>

<ng-template #nextButton>
  <button class="btn btn-xs btn-primary" jhiTranslate="tour.button.nextButton">Vai avanti</button>
</ng-template>
<ng-template #prevButton>
  <button class="btn btn-xs btn-primary" jhiTranslate="tour.button.prevButton">Torna Indietro</button>
</ng-template>
<ng-template #doneButton>
  <button class="btn btn-xs btn-success" jhiTranslate="tour.button.doneButton">Fine</button>
</ng-template>
<ng-template #primoStep>
  <h3 jhiTranslate="tour.prenota-nuovo-appuntamento.primoStep-h3">Se vuoi prenotare un'appuntamento per te stesso premi "Per Me"</h3>
  <p jhiTranslate="tour.prenota-nuovo-appuntamento.primoStep-p">Verranno utilizzate le informazioni presenti nel tuo profilo utente</p>
</ng-template>
<ng-template #secondoStep>
  <h3 jhiTranslate="tour.prenota-nuovo-appuntamento.secondoStep-h3">Se vuoi prenotare un'appuntamento per un altra persona stesso premi "Per un altro"</h3>
  <p jhiTranslate="tour.prenota-nuovo-appuntamento.secondoStep-p">Dovranno essere inserite manualmente le informazioni della persona interessata</p>
</ng-template>

